import instance from "..";

// ✅ LOGIN
export const loginAction: any =
  (payload: { email: string; password: string }) =>
  async () => {
    try {
      const res = await instance.post(`/api/v1/auth/signin`, payload);

      const apiResponse = res?.data;

      if (!apiResponse?.success || !apiResponse?.data) {
        throw new Error(apiResponse?.message || "Login failed");
      }

      return apiResponse;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ LOGOUT (OPTIONAL API CALL)
export const logOutAction: any = () => async () => {
  try {
    // If backend logout API exists, call here
    return true;
  } catch {
    return true;
  }
};